import React from 'react';
import { useTranslation } from 'react-i18next';

import { Block, ErrorBlock } from '../../Block';
import SelfSubmittingForm from '../../SelfSubmittingForm';
import ErrorBoundary from '../../ErrorBoundary';

function isPayture(invoice) {
  return typeof invoice.url === 'string' && invoice.url.endsWith('ipay/card');
}

function PaytureIframe({
  invoice: {
    data: { iframe_source },
  },
}) {
  return (
    <Block>
      <div className="iframe__overlay">
        <iframe className="iframe" src={iframe_source} title="payture-iframe" />
      </div>
    </Block>
  );
}

function isWinpay(invoice) {
  return typeof invoice.url === 'string' && invoice.url.endsWith('ipay/wcard');
}

function WinpayIframe({ invoice: { data: iframeData } }) {
  const { wp_url, wp_method, data, sign } = iframeData;

  return (
    <Block>
      <div className="iframe__overlay iframe__overlay--winpay">
        <iframe
          className="iframe iframe--winpay"
          width="100"
          scrolling="yes"
          id="winpayIframe"
          name="winpayIframe"
          title="winpay-iframe"
        />
      </div>
      <SelfSubmittingForm
        method={wp_method}
        action={wp_url}
        target="winpayIframe"
        data={{ data, sign }}
      />
    </Block>
  );
}

const iframes = [
  {
    check: isPayture,
    Component: PaytureIframe,
  },
  {
    check: isWinpay,
    Component: WinpayIframe,
  },
];

export default function IframeCard({ invoice }) {
  const { t } = useTranslation();
  const iframe = iframes.find(({ check }) => check(invoice));

  if (!iframe) {
    return <ErrorBlock headerText={t('DefaultError')} />;
  }

  return (
    <ErrorBoundary
      fallback={<ErrorBlock headerText={t('DefaultError')} />}
      severity={'error'}
    >
      <iframe.Component invoice={invoice} />
    </ErrorBoundary>
  );
}
